<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-date-picker
          :min="today"
          v-model="dates"
          multiple
      ></v-date-picker>
    </v-col>
    <v-col cols="12" sm="6">
      <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="dates"
          transition="scale-transition"
          offset-y
          min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-combobox
              v-model="dates"
              multiple
              chips
              small-chips
              label="Multiple picker in menu"
              prepend-icon="event"
              readonly
              v-bind="attrs"
              v-on="on"
          ></v-combobox>
        </template>
        <v-date-picker :min="today" v-model="dates" multiple no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(dates)">OK</v-btn>
        </v-date-picker>
      </v-menu>
      <template v-if="dates.length > 0">
        <md-field :mdClearable="true">
          <label for="newCoef">{{ local_page_keys.lable_date_coeff_create }}</label>
          <md-input v-model="newCoef" step="0.1" min="0.1"
                    ref="newCoef"
                    name="newCoef" id="newCoef" type="number"></md-input>
        </md-field>
        <md-field v-if="newCoef !== '' && newCoef > 0">
          <md-button class="md-success" @click="saveCoef">
            <md-icon>done</md-icon>
          </md-button>
          <md-button class="md-default">
            <md-icon @click="$event = 'closeWindow'">close</md-icon>
          </md-button>
        </md-field>

      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "MultipleDatesHolidaysCraete",
  props: {
    local_page_keys : {
      type: Object,
      require: true
    }
  },
  data: () => ({
    today: new Date(new Date().getTime() + 24*3600*1000).toISOString().substr(0, 10),
    dates: [],
    menu: false,
    newCoef: ''
  }),
  methods: {
    closeDialog() {
      this.$emit('closeWindow', true)
    },
    async saveCoef() {
      let row = [];
      for (let date of this.dates) {
        row.push({
          date: date,
          coeff: this.newCoef,
        })
      }
      await this.$store.dispatch('holidaySettings/createdHolidays', {row});
      let data = await this.$store.getters['holidaySettings/createdHolidays'];
      if (Object.keys(data).includes('Status') && data.Status === "Ok") {
        this.$emit('reload', true);
        this.$emit('closeWindow', true);
      } else {
        alert(this.local_page_keys.error_update)
        this.$emit('closeWindow', true)
      }

    }
  },

}
</script>

<style scoped>

</style>